module.exports = __webpack_public_path__ + "static/media/karachi.9cc739fe.svg";